import { render, staticRenderFns } from "./GroupsTeamDetailPage.vue?vue&type=template&id=64e26274&scoped=true&"
import script from "./GroupsTeamDetailPage.vue?vue&type=script&lang=js&"
export * from "./GroupsTeamDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTeamDetailPage.vue?vue&type=style&index=0&id=64e26274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e26274",
  null
  
)

export default component.exports